module.exports = __webpack_public_path__ + "media/images/partners/depkult2025-dd93054483b72ed96c61c664918953fc.svg";